import { Helper } from "../../../../dev/utils/Helper";
import { TextStyleOptions, BitmapTextStyleOptions } from '../../../../dev/setting/text/IText';
import {  RoadRage } from "../../../RoadRage";
import  {SplashView } from "../SplashController";
import { gsap,Power2 } from "gsap";
import { GameAssets } from '../../../config/texture/GameAssets';
import { FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { GameData } from '../../../server/data/BaseModel';
import { SpinePlayer } from '../../../../dev/displayobject/SpinePlayer';
import { RoadRageCounter } from '../../countup/RoadRageCounter';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { SoundManager } from '../../../config/sound/SoundManager';

export class SplashViewBrokeTheBank extends PIXI.Container implements SplashView  {
   
    private _timeLine:gsap.core.Timeline;

    private totalWin: PIXI.Text;
    private totalWinAmm: number;
    private isTotalWin: boolean;

    private DEFAULT_TXT_STYLE:TextStyleOptions;
    private counter:RoadRageCounter;

    private _gfxBg:PIXI.Graphics;
    private _spine:SpinePlayer;

    private readonly styleTotal: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontSize: 68,
        fontWeight: FontWeight.EXTRA_BOLD,
        fill: [
            "#fffb00",
            "#c93",
        ],
        stroke: "#600",
        strokeThickness: 4
    };

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 62,
        letterSpacing: 12
    };

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
        this.init();
        this.alpha = 0;
    }

    setData(data:GameData){
        this.isTotalWin = data.Win.singleWin === data.Win.totalWin;
        this.totalWinAmm = data.Win.totalWin;
    }

    private get shortPropWV():boolean{
        return RoadRage.apiPlugin.gameClientConfiguration.useCensoredGfxUS;
    }

    private get juriWinCapStart():string{
        return this.shortPropWV ? "Win_Cap_Start_WV" : "Win_Cap_Start";
    }
    private get juriWinCap():string{
        return this.shortPropWV ? "Win_Cap_WV" : "Win_Cap";
    }
    private get juriWinCapEnd():string{
        return  this.shortPropWV ? "Win_Cap_End_WV" : "Win_Cap_End";
    }

    private init():void{

        const maxAreaSize: number = 3000;
        this._gfxBg = this.addChild(new PIXI.Graphics());
        this._gfxBg.beginFill(0x000000, 1);
        this._gfxBg.drawRect(-maxAreaSize * 0.5, -maxAreaSize * 0.5, maxAreaSize, maxAreaSize);
        this._gfxBg.endFill();

        this._spine = this.addChild(new SpinePlayer("Win_Cap",false));
        this._spine.scale.set(1.5);

        // TEXT TOTAL
        // this.totalWin = new PIXI.Text(Translator.translate(TranslationTexts.TOTAL_WIN));
        // this.totalWin.style = this.styleTotal;
        // this.totalWin.position = new PIXI.Point(0, -240);
        // this.totalWin.anchor.set(0.5, 0.5);
        // this.addChild(this.totalWin);

        this.counter = this.addChild(new RoadRageCounter());
        this.counter.position.set(0,0)
        this.addChild(this.counter);
    }

    public play():gsap.core.Timeline{

        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({onStart:() => {this.visible = true}}));
        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 0.25, alpha: 1 }, 0);
        
        SoundManager.fadeOutAmbient(500);
        this._timeLine.add(() =>{ SoundManager.playSoundEffect("winCapCountUp")},0.25)
        
        this._timeLine.add(this.counter.playBigWin(0,this.totalWinAmm,10.25),0);
        this._timeLine.add(() => { 
            this._spine.play({animation:this.juriWinCapStart, duration:2});
            this._spine.alpha = 0;
            Helper.setTimeline().to(this._spine,{alpha:1,duration:1}).to(this._spine,{alpha:0,duration:1})
         },4.5)
            
        SlotGame.keypadPlugin.setWin(this.totalWinAmm, this.isTotalWin, false);
        
        this._timeLine.add(() => { 
            this.counter.bounceHit(8);
            SlotGame.keypadPlugin.setWin(this.totalWinAmm, this.isTotalWin, false);
        })
        this._timeLine.add(() => {
            SoundManager.playSoundEffect("winCapLoop",Number.MAX_SAFE_INTEGER);
            this._spine.play({ animation:this.juriWinCap,showOnEnd:true, onComplete:() => { this._spine.play({animation:this.juriWinCapEnd,loop:true})}})
            Helper.setTimeline().to(this._spine,{alpha:1,duration:0.25});
        });

        this._timeLine.to(this.counter,{alpha:0, duration:2},"+=0.5");

        this._timeLine.to(this,{duration:1});

        return this._timeLine;
    }

    public stop():gsap.core.Timeline{
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onComplete:() => {
            this.visible = false;
            this._spine.stop();
        }}));

        SoundManager.playSoundEffect("winCapEnd");
        SoundManager.stopSoundEffect("winCapLoop");

        this._timeLine.add(() =>  { RoadRage.counter.stop(undefined,0.25,0,true) });

        this._timeLine.to(this, {duration:1,alpha:0});

        return this._timeLine;
    }

    public onResize():void{
        this.counter.onResize();
        // if(this._timeLine) this._timeLine.progress(1);
    }
}
